'use strict'

angular
  .module('basalteApp')
  .constant('BAS_DISCOVERY', {
    EVT_DISCOVERED_CORES_UPDATED: 'evtBasDiscoveryDiscoveredCoresUpdated'
  })
